export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          पुरुष एशिया हॉकी कप 2025
        </h3>

        <p className="card-text">
          बिहार पहली बार हीरो एशिया कप 2025 की मेजबानी करने के लिए तैयार है। यह
          प्रतिष्ठित पुरुष हॉकी टूर्नामेंट 29 अगस्त से 7 सितंबर तक राजगीर खेल
          परिसर के अत्याधुनिक अंतरराष्ट्रीय हॉकी स्टेडियम में आयोजित होगा। इस
          टूर्नामेंट का 12वां संस्करण वैश्विक मंच पर बिहार की खेल क्षमता को
          प्रदर्शित करने का सुनहरा अवसर है। इस महाकुंभ में भारत, चीन, जापान,
          चीनी ताइपे, मलेशिया, कोरिया और ओमान की शीर्ष टीमें अपनी प्रतिभा का
          प्रदर्शन करेंगी। यह आयोजन हॉकी प्रेमियों को रोमांचक मुकाबलों का गवाह
          बनने का शानदार मौका देगा।
        </p>
        <p className="card-text">
          हीरो एशिया कप का इतिहास गौरवशाली रहा है, जिसमें कोरिया ने पाँच बार
          खिताब जीतकर अपना दबदबा बनाया है, जबकि भारत और पाकिस्तान तीन-तीन बार
          चैंपियन रहे हैं। इस टूर्नामेंट का विजेता सीधे हॉकी विश्व कप के लिए
          क्वालीफाई करेगा, जो इस आयोजन को वैश्विक स्तर पर और भी महत्वपूर्ण बनाता
          है। बिहार में इस टूर्नामेंट का आयोजन न केवल राज्य की संगठनात्मक क्षमता
          को प्रदर्शित करेगा, बल्कि वैश्विक पटल पर बिहार की खेल छवि को नई
          ऊंचाइयों तक ले जाएगा।
        </p>
        <p className="card-text">
          इस ऐतिहासिक आयोजन को और भी भव्य बनाने के लिए, 17 अगस्त से एक ट्रॉफी
          गौरव यात्रा शुरू होगी। यह यात्रा बिहार के सभी जिलों के साथ-साथ चेन्नई,
          चंडीगढ़ (पंजाब, हरियाणा), दिल्ली, ओडिशा, असम और झारखंड जैसे राज्यों से
          होकर गुजरेगी। यह यात्रा युवाओं में हॉकी के प्रति उत्साह और जुनून
          जगाने, खेल संस्कृति को बढ़ावा देने और इस आयोजन को जन-जन तक पहुँचाने का
          एक अनूठा प्रयास है।
        </p>
        <p className="card-text">
          राजगीर खेल परिसर में इस टूर्नामेंट का सफल आयोजन बिहार के लिए गर्व का
          क्षण होगा। यह न केवल राज्य में खेल के स्तर को ऊपर उठाएगा, बल्कि
          पर्यटन, कला और संस्कृति के क्षेत्र में भी बिहार की वैश्विक पहचान को
          मजबूत करेगा। यह आयोजन बिहार के लिए एक ऐतिहासिक मील का पत्थर साबित
          होगा, जो खेल प्रेमियों और राज्यवासियों को एकजुट कर हॉकी के इस महाकुंभ
          को अविस्मरणीय बनाएगा।
        </p>
        <br />
      </div>
    </div>
  );
}
